import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  getFeatures,
  getEffectivePreferences,
  type FeatureFlags,
  type EffectivePreferences,
} from '../services/features';

// Capacidades del usuario logado. Es lo que deben usar las pantallas para
// decidir qué mostrar — nunca `claims` directamente (ver services/features.ts).
export function useFeatures(): FeatureFlags {
  const { claims } = useAuth();
  return useMemo(() => getFeatures(claims), [claims]);
}

// Preferencias efectivas (las guardadas, recortadas por el perfil).
//
// A propósito NO se memoiza: las preferencias viven en localStorage y se leen en
// cada render —igual que hacía getPreferences()— para que un cambio hecho en
// Ajustes se refleje al instante sin recargar la página.
export function useAppPreferences(): EffectivePreferences {
  const { claims } = useAuth();
  return getEffectivePreferences(claims);
}
